import React from 'react';
import moment from 'moment';

import EditSectionDateTime from '../../../../presentation/EditSectionDateTime';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';

import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

// Displays a basic (label -- input) field
class BasicInput extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      label: props.label === undefined ? 'label?' : props.label,
      value: props.value === undefined ? '0.00' : props.value,
      onChange: props.onChanged,
      name: props.name
    };

    // Bindings
    this.onChanged = this.onChanged.bind( this );
  }

  // Props passed in to this component
  componentWillReceiveProps( nextProps ){
    this.setState( {
      value: nextProps.value,
      label: nextProps.label
    } );
  }

  // Fires when the input field is changed
  onChanged( e ){
    const prev_value = this.state.value;
    const value = e.target.value;
    if( prev_value !== value ){
      this.setState( {
        value: value
      } );
      if( this.state.onChange !== undefined ){
        let payload = {value: value, name: this.state.name};
        this.state.onChange( payload );
      }
    }
  }

  // Renders a label -- input field
  render() {
    const value = this.state.value; // input text value
    return (
      <div className={'vform-input-area'}>
        <span className={'vform-input-label'}>
          <span>{ this.state.label }</span>
        </span>
        <span className={'vform-input-field'}>
          <EditSectionInput value={ value } width="100%" onChanged={this.onChanged}/>
        </span>
      </div>
    );
  }
}



// Displays Multiple input for one label
class MultiInput extends React.Component {
  constructor( props ){
    super( props );

    // This will allow for multiple inputs to render per one label, however
    // if we want something like a BasicInput with the format of a MultiInput
    // setting the mode to 'column' will accomplish this
    let mode = props.mode === undefined ? 'standard' : props.mode; // 'column' or 'standard'
    let inputnumber = props.inputnumber === undefined ? 2 : props.inputnumber; // how inputs to render
    let scale = parseInt( 60 / inputnumber, 10 ); // Spacing (size ~ column mode)

    this.state = {
      inputnumber: inputnumber,
      label: props.label === undefined ? 'multi-input-label' : props.label,
      scale: scale,
      mode: mode,
      name: props.name,
      inputs: props.values,
      onInputChanged: props.onInputChanged // Parent state change function
    };

    // Bindings
    this.onChangeInput = this.onChangeInput.bind( this );
  }

  // Props passed down
  componentWillReceiveProps( nextProps ){
    this.setState( {
      inputs: nextProps.values,
      label: nextProps.label
    } );
  }

  // Renders all the fields in a X(inputnumber) by 1 format (flex column styled) 
  onRenderFields(){
    let fields = [];
    let scale = this.state.scale;
    let name = this.state.name;
    const value_array = this.state.inputs;

    if( this.state.mode === 'column' ){
      scale = 20; // Base size for one
    }
    
    // Scaling based on number of input fields wanted
    for( let i = 0; i < this.state.inputnumber; i++ ){
      const value = value_array[i] === undefined ? '' : value_array[i];

      // flexbox (css) takes care of the spacing
      fields.push( 
        <span key={'vform-multi-input-' + i + '__' + this.state.label} className={'vform-multi-input-span'} style={{width: '100%', paddingRight: '10px'}}>
          <EditSectionInput value={ value } width={scale + '%'} onChanged={( e ) => this.onChangeInput( e, i, name )} />
        </span> 
      );
    }

    return fields;
  }

  //
  onChangeInput( e, position, name ){
    let value = e.target.value;
    let new_inputs = this.state.inputs;
    new_inputs[position] = value;
    
    this.setState( {
      inputs: new_inputs
    } );

    if( this.state.onInputChanged !== undefined ){
      let payload = {value: value, position: position, name: this.state.name};
      this.state.onInputChanged( payload );
    }
  }

  render(){
    return (
      <div className={'vform-input-area'}>
        <span className={'vform-input-label'}>
          <span>{ this.state.label }</span>
        </span>
        {this.onRenderFields()}
      </div>
    );
  }
}


// The form, stores user inputs, and displays previous report(s) data
class InvoiceForm extends React.Component {
  constructor( props ) {
    super( props );

    // Creating the first day of the month
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let first = new Date( year, month, 1 );
    let first_day_of_the_month = moment( first ).format( 'MM-DD-YYYY' );

    // The state
    this.state = {
      title: props.title === undefined ? 'Invoice for ' : 'Invoice for ' + props.title,
      vendor: props.vendor === undefined ? 'WCS' : props.vendor, // WCS is the default vendor

      // Error handling
      hasError: false,
      error: {},
      info: {},

      date: first_day_of_the_month,

      // Inputs (stores all the inputs)
      inputs_wcs: {  
        // Summary of Charges
        new_usage_charges: '0.00',
        recurring_charges: '0.00',
        non_recurring_charges: '0.00',
        taxes_and_fees: '0.00',
        total_new_charges: '0.00',
        
        // Detail of New Charges
        total_outbound_dedicated_calls: '0',
        total_outbound_dedicated_minutes: '0',
        total_outbound_dedicated_cost: '0',
        total_toll_free_calls: '0',
        total_toll_free_minutes: '0',
        total_toll_free_cost: '0',
        total_free_calls: '0',
        total_free_minutes: '0',
        total_free_cost: '0',
        total_new_usage_charges_calls: '0',
        total_new_usage_charges_minutes: '0',
        total_new_usage_charges_cost: '0',
        total_taxes_and_fees: '0'
      },

      // Possible future inputs
      inputs_att: {
        // Summary of Charges
        new_usage_charges: '0.00',
        recurring_charges: '0.00',
        non_recurring_charges: '0.00',
        taxes_and_fees: '0.00',
        total_new_charges: '0.00',
        
        // Detail of New Charges
        total_outbound_dedicated_calls: '0',
        total_outbound_dedicated_minutes: '0',
        total_outbound_dedicated_cost: '0',
        total_toll_free_calls: '0',
        total_toll_free_minutes: '0',
        total_toll_free_cost: '0',
        total_free_calls: '0',
        total_free_minutes: '0',
        total_free_cost: '0',
        total_new_usage_charges_calls: '0',
        total_new_usage_charges_minutes: '0',
        total_new_usage_charges_cost: '0',
        total_taxes_and_fees: '0'
      }
    };

    // Optimizing calls
    this._render = true; // This will cause the form to update or not. This is basically
    // a global value in react and is above the state, doing this in the
    // state is not reliable, this is the proper way to optimize render calls

    // Bindings
    this.onRenderTitle = this.onRenderTitle.bind( this );
    this.onRenderLeftBody = this.onRenderLeftBody.bind( this );
    this.onRenderRightBody = this.onRenderRightBody.bind( this );
    
    // -- Events
    this.onChangeVendor = this.onChangeVendor.bind( this );
    this.onChangeDate = this.onChangeDate.bind( this );
    this.onBasicInputChanged = this.onBasicInputChanged.bind( this );
    this.onMultiInputChanged = this.onMultiInputChanged.bind( this );
    this.onSave = this.onSave.bind( this );
    this.onCancel = this.onCancel.bind( this );
    
    // Validation and clearing of state inputs
    this.onClear = this.onClear.bind( this );
    this.setValues = this.setValues.bind( this );

    // Global calls to Alerts and bugsnag
    this.alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
  }

  // Error Handling
  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  // Loads WCS (default first) for current month on component mounting
  componentDidMount(){
    this.onGetInvoice( 'WCS', undefined );
  }

  // Renders only if state is told to render, this flag can be set
  // on or off by other components to force a state change to occur,
  // for those who review code commits ;) this is a nice optimizing
  // snippet and we should use this more in the future. #DayronOriginal
  shouldComponentUpdate( nextProps, nextState ) {
    return this._render === undefined ? false : this._render;
  }

  // Renders the title of the form, e.i "Invoice for WCS:"
  onRenderTitle(){
    // WCS is default (and currently only vaLid one), AT&T is a possible future vendor
    return ( <div className={'vform-body-big-title-header'}>
      {this.state.title}
      <span className={'detail-view-column'}>
        <EditSectionDropdown id={'vform-staticdropdown'} options={ [{id: 'WCS', text: 'WCS'}, {id:'AT&T', text:'AT&T'}] } 
          value={this.state.vendor} width="50%" onChanged={this.onChangeVendor}/>
      </span>
    </div> );
  }

  // Gets the invoice information based on Vendor and Date from the backend
  onGetInvoice( vendor_name, invoice_date ){
    let api = new EtelAPI( 'invoice' );
    let payload = [];

    // Use state if not given
    if( vendor_name === undefined ){
      vendor_name = this.state.vendor;
    }

    // Use state if not given
    if( invoice_date === undefined ){
      invoice_date = this.state.date;
    }

    // payload.push( {'WCS_Invoice_Data_ID': 0}); // Default
    payload.push( {'Vendor_Name': vendor_name} );
    payload.push( {'Invoice_Date': invoice_date} );

    // Sets the inputs based on the value returned
    api.get( payload ).then( ( result ) =>{
      this.setValues( result, vendor_name, invoice_date );
    
    // On error display error
    } ).catch( ( error ) => {
      this.alerts.WARNING( 'Vendor Invoices', 'Could not load ' + vendor_name + ' on ' + invoice_date );
    } );
  }

  // Sets the values of the current state
  setValues( results, vendor, date ){

    if( results.length === 0 ){
      this.alerts.INFO( 'Vendor Invoice', 'No report for ' + vendor + ' on ' + date );
      this.onClear();
    } else {
      if( results.length > 1 ){
        // Can not happen
        this.alerts.CRITICAL( 'Vendor Invoices', 'There are more than one report for ' + vendor + 'on ' + date, 5000 );
      } else {
        const result = results[0];
        this.alerts.SUCCESS( 'Vendor Invoices', 'Successfully loaded ' + vendor + ' Invoice', 5000 );
        
        // WCS only
        if( vendor === 'WCS' ){
          let new_inputs = this.state.inputs_wcs;
          new_inputs['new_usage_charges'] = result['NC_NewUsageCharges'];
          new_inputs['recurring_charges'] = result['NC_RecurringCharges'];
          new_inputs['non_recurring_charges'] = result['NC_NonRecurringCharges'];
          new_inputs['taxes_and_fees'] = result['NC_TaxesAndFees'];
          new_inputs['total_new_charges'] = result['NC_TotalNewCharges'];

          new_inputs['total_outbound_dedicated_calls'] = result['Outbound_Calls_SubTotal'];
          new_inputs['total_outbound_dedicated_minutes'] = result['Outbound_Minutes_SubTotal'];
          new_inputs['total_outbound_dedicated_cost'] = result['Outbound_Cost_SubTotal'];

          new_inputs['total_toll_free_calls'] = result['TF_Calls_SubTotal'];
          new_inputs['total_toll_free_minutes'] = result['TF_Minutes_SubTotal'];
          new_inputs['total_toll_free_cost'] = result['TF_Cost_SubTotal'];

          new_inputs['total_free_calls'] = result['Switched_Calls_SubTotal'];
          new_inputs['total_free_minutes'] = result['Switched_Minutes_SubTotal'];
          new_inputs['total_free_cost'] = result['Switched_Cost_SubTotal'];

          new_inputs['total_new_usage_charges_calls'] = result['Totals_Calls'];
          new_inputs['total_new_usage_charges_minutes'] = result['Totals_Minutes'];
          new_inputs['total_new_usage_charges_cost'] = result['Totals_Cost'];
          
          new_inputs['total_taxes_and_fees'] = result['Totals_TaxesAndFees'];

          this.setState( {
            inputs_wcs: new_inputs
          } );
        }
      }
    }
  }

  // Renders the left side of the body
  onRenderLeftBody(){

    let value_group;
    const vendor = this.state.vendor;

    // WCS
    if( vendor === 'WCS' ){
      value_group = this.state.inputs_wcs;
    
    // AT&T (possible future)
    } else if( vendor === 'AT&T' ){
      value_group = this.state.inputs_att;
    }

    // Same values being shown
    if( vendor === 'WCS' || vendor === 'AT&T' ){
      return (
        <div className={'vform-body-left'}>
          <div className={'vform-body-big-title'}> Summary of Charges </div>
          <div className={'vform-body-segment-title'} style={{marginLeft: '10%'}}> New Charges </div>
          <BasicInput 
            label={'New Usage Charges: '} 
            onChanged={this.onBasicInputChanged} 
            value={value_group['new_usage_charges']}
            name={'new_usage_charges'} />
          <BasicInput
            label={'Recurring Charges: '}
            onChanged={this.onBasicInputChanged}
            value={value_group['recurring_charges']} 
            name={'recurring_charges'} />
          <BasicInput
            label={'Non-Recurring Charges: '}
            onChanged={this.onBasicInputChanged}
            value={value_group['non_recurring_charges']}
            name={'non_recurring_charges'} />
          <BasicInput
            label={'Taxes and Fees: '}
            onChanged={this.onBasicInputChanged}
            value={value_group['taxes_and_fees']}
            name={'taxes_and_fees'} />
          <BasicInput
            label={'Total New Charges: '}
            onChanged={this.onBasicInputChanged}
            value={value_group['total_new_charges']}
            name={'total_new_charges'} />
        </div>
      );
    } else {
      // On other none defined values
      return ( <div></div> );
    }
  }

  // Renders the right side of the body
  onRenderRightBody(){

    let values = {};
    const vendor = this.state.vendor;
    
    if( vendor === 'WCS' ){
      values = this.state.inputs_wcs;
    } else if( vendor === 'AT&T' ){
      values = this.state.inputs_att;
    }

    // WCS and AT&T have the same possible fields
    return (
      <div className={'vform-body-right'}>
        <div className={'vform-body-big-title'}> Detail of New Charges </div>
        <div className={'vform-m-input-label-first'}> # of Calls </div>
        <div className={'vform-m-input-label-else'}> Minutes </div>
        <div className={'vform-m-input-label-else'}> Cost </div>
        <MultiInput
          inputnumber={3} 
          values={[
            values['total_outbound_dedicated_calls'],
            values['total_outbound_dedicated_minutes'],
            values['total_outbound_dedicated_cost']
          ]}
          name={'total_outbound_dedicated'}
          label={'Total Outbound 1+ (Dedicated): '}
          onInputChanged={this.onMultiInputChanged} />
        <MultiInput 
          inputnumber={3}
          values={[
            values['total_toll_free_calls'],
            values['total_toll_free_minutes'],
            values['total_toll_free_cost']
          ]}
          name={'total_toll_free'}
          label={'Total Toll Free (Dedicated): '} 
          onInputChanged={this.onMultiInputChanged} />
        <MultiInput
          inputnumber={3}
          values={[
            values['total_free_calls'],
            values['total_free_minutes'],
            values['total_free_cost']
          ]}
          name={'total_free'}
          label={'Total Free (Switched): '}
          onInputChanged={this.onMultiInputChanged} />
        <MultiInput
          inputnumber={3}
          values={[
            values['total_new_usage_charges_calls'],
            values['total_new_usage_charges_minutes'],
            values['total_new_usage_charges_cost']
          ]}
          name={'total_new_usage_charges'}
          label={'Total New Usage Charges: '}
          onInputChanged={this.onMultiInputChanged} />
        <MultiInput
          inputnumber={1}
          values={[
            values['total_taxes_and_fees']
          ]}
          name={'total_taxes_and_fees'}
          mode={'column'}
          label={'Total Taxes and Fees: '} 
          onInputChanged={this.onMultiInputChanged} />
      </div>
    );
  }

  // Renders the top (time) portion of the form
  onRenderHeader(){
    return (            
      <div className={'vform-dt-group'}>
        <div className={'vform-dt-input'}>
          <span className='vform-dt-label'>{ 'Invoice Date' }</span>
          <EditSectionDateTime 
            id={'vform-dt'}
            width="100%"
            value={this.state.date}
            dateFormat={'MM-DD-YYYY'}
            timeFormat={false}
            onChange={this.onChangeDate} />
        </div>
      </div>
    );
  }

  // Renders the buttons
  onRenderFooter(){
    return(
      <div className={'vform-button-area'}>
        <button className={'vform-button-cancel'} onClick={this.onCancel}>
          <span className='detail-view-content-label'>{'Cancel'}</span>
        </button>
        <button className={'vform-button-save'} onClick={this.onSave}>
          <span className='detail-view-content-label'>{'Save'}</span>
        </button>
      </div>
    );
  }

  // Changing vendors
  onChangeVendor( e ){
    const new_value = e.target.value;

    // This will load previous values that are saved in the state
    if( new_value !== undefined ){
      this._render = true; // Render new values to the form, this will populate the proper values
      // per vendor
      this.setState( {
        vendor: new_value
      } );

      this.onGetInvoice( new_value, undefined );
    }
  }

  // Left side (single column) input changed, this will not caused the form to render,
  // even though a form.state value was updated
  onBasicInputChanged( payload ){
    let vendor = this.state.vendor; // State input group
    let name = payload.name; // State input name
    let new_inputs;
    
    // WCS specific values
    if( vendor === 'WCS' ){

      new_inputs = this.state.inputs_wcs;
      if( new_inputs !== undefined ){
        new_inputs[name] = payload.value;
        
        // Not updating the form just the state
        this._render = false;
        this.setState( {
          inputs_wcs: new_inputs
        } );
      }

    // AT&T values
    } else if ( vendor === 'AT&T' ){
      
      new_inputs = this.state.inputs_att;
      if( new_inputs !== undefined ){
        new_inputs[name] = payload.value;
        
        // Not updating the form just the state
        this._render = false;
        this.setState( {
          inputs_att: new_inputs
        } );
      }
    }
  }
  
  // Does not force Form to render, only children will update
  onMultiInputChanged( payload ){
    const vendor = this.state.vendor;
    const name = payload['name'];
    const value = payload['value'];
    const pos = payload['position'];

    let pos_names;
    let new_inputs;

    if( vendor === 'WCS' ){
      new_inputs = this.state.inputs_wcs;
      pos_names = ['_calls', '_minutes', '_cost'];
      
      if( name === 'total_taxes_and_fees' ){
        new_inputs['total_taxes_and_fees'] = value;
      } else {
        new_inputs[name + pos_names[pos]] = value;
      }

      this._render = false;
      this.setState( {
        inputs_wcs: new_inputs
      } );

    } else if( vendor === 'AT&T' ) {
      new_inputs = this.state.inputs_att;
      pos_names = ['_calls', '_minutes', '_cost'];
      
      if( name === 'total_taxes_and_fees' ){
        new_inputs['total_taxes_and_fees'] = value;
      } else {
        new_inputs[name + pos_names[pos]] = value;
      }

      this._render = false;
      this.setState( {
        inputs_att: new_inputs
      } );
    }
  }

  // Time picker change event
  onChangeDate( e ){
    // Time picker is not an flexible so the form must be re-rendered
    this._render = true;
    this.setState( {
      date: e.target.value
    } );

    this.onGetInvoice( undefined, e.target.value );
  }

  // Saving (or updating) fields
  onSave(){
    const vendor = this.state.vendor;
    const date = this.state.date;
    let api = new EtelAPI( 'invoice' );
    let payload = {};

    // Only WCS for now
    if( vendor === 'WCS' ){
      const inputs = this.state.inputs_wcs;

      payload['WCS_Invoice_Data_ID'] = 0; // Default
      payload['Vendor_Name'] = 'WCS';
      payload['Invoice_Date'] = this.state.date;

      // Defaults
      payload['Year'] = 0;
      payload['Month'] = 0;
      payload['CCFileMonth'] = 0;

      // Total New Charges
      payload['NC_NewUsageCharges'] = parseFloat( inputs['new_usage_charges'] );
      payload['NC_RecurringCharges'] = parseFloat( inputs['recurring_charges'] );
      payload['NC_NonRecurringCharges'] = parseFloat( inputs['non_recurring_charges'] );
      payload['NC_TaxesAndFees'] = parseFloat( inputs['taxes_and_fees'] );
      payload['NC_TotalNewCharges'] = parseFloat( inputs['total_new_charges'] );

      // Detail of New Charges Section
      //  --Total Outbound 1+ (Dedicated)
      payload['Outbound_Calls_SubTotal'] = parseInt( inputs['total_outbound_dedicated_calls'], 10 );
      payload['Outbound_Minutes_SubTotal'] = parseFloat( inputs['total_outbound_dedicated_minutes'] );
      payload['Outbound_Cost_SubTotal'] = parseFloat( inputs['total_outbound_dedicated_cost'] );
      //  --Total Toll Free Dedicated
      payload['TF_Calls_SubTotal'] = parseInt( inputs['total_toll_free_calls'], 10 );
      payload['TF_Minutes_SubTotal'] = parseFloat( inputs['total_toll_free_minutes'] );
      payload['TF_Cost_SubTotal'] = parseFloat( inputs['total_toll_free_cost'] );
      //  --Total Toll Free Switched OPTIONAL - MAY NOT BE ON THE INVOICE, DEFAULT TO 0'S
      payload['Switched_Calls_SubTotal'] = parseInt( inputs['total_free_calls'], 10 );
      payload['Switched_Minutes_SubTotal'] = parseFloat( inputs['total_free_minutes'] );
      payload['Switched_Cost_SubTotal'] = parseFloat( inputs['total_free_cost'] );
      //  --Total New Usage Charges
      payload['Totals_Calls'] = parseInt( inputs['total_new_usage_charges_calls'], 10 );
      payload['Totals_Minutes'] = parseFloat( inputs['total_new_usage_charges_minutes'] );
      payload['Totals_Cost'] = parseFloat( inputs['total_new_usage_charges_cost'] );
      //  --Total Taxes and Fees
      payload['Totals_TaxesAndFees'] = parseFloat( inputs['total_taxes_and_fees'] );

      payload['ModifiedByUser'] = 0;

      api.get( [{'Vendor_Name': vendor}, {'Invoice_Date': date}] ).then( ( result ) =>{
        
        // Add new invoice
        if( result.length === 0 ){
          api.insert( payload ).then( ( result ) =>{
            this.alerts.SUCCESS( 'Vendor Invoices', 'Successfully created new WCS Invoice', 5000 );
            this.onGetInvoice( vendor, date ); // Clear the inputs (fetch data if exist)
          
          // On error
          } ).catch( ( error ) => {
            const status = error.status === undefined ? 0 : error.status;
        
            if( status === 401 ) {
              this.alerts.INFO( 'Vendor Invoices', 'Your session has expired.' , 3000 );
              this.doLogOff();
            } else if( status === 500 ) {
              this.alerts.INFO( 'Vendor Invoices', error.statusText , 3000 );
              this.doLogOff();
            } else {
              this.alerts.CRITICAL( 'Vendor Invoices', error );
            }
          } );
        } else {
          // Setting the ID
          payload['WCS_Invoice_Data_ID'] = result[0]['WCS_Invoice_Data_ID'];
          api.update( payload ).then( ( result ) =>{
            this.alerts.SUCCESS( 'Vendor Invoices', 'Successfully updated WCS Invoice for ' + date, 5000 );
            this.onGetInvoice( vendor, date ); // Clear the inputs (fetch data if exist)
          
          // On error
          } ).catch( ( error ) => {
            const status = error.status === undefined ? 0 : error.status;
        
            if( status === 401 ) {
              this.alerts.INFO( 'Vendor Invoices', 'Your session has expired.' , 3000 );
              this.doLogOff();
            } else if( status === 500 ) {
              this.alerts.INFO( 'Vendor Invoices', error.statusText , 3000 );
              this.doLogOff();
            } else {
              this.alerts.CRITICAL( 'Vendor Invoices', error );
            }
          } );
        }
      } ).catch( ( error ) =>{
        this.alerts.CRITICAL( 'Vendor Invoices', error );
      } );
    }
  }

  // Canceling (clears input), this will not fetch inputs from the backend
  onCancel( e ){

    // Creating the first day of the month
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();
    let first = new Date( year, month, 1 );
    let first_day_of_the_month = moment( first ).format( 'MM-DD-YYYY' );

    // Inputs (stores all the inputs)
    let clear_wcs = {  
      // Summary of Charges
      new_usage_charges: '0.00',
      recurring_charges: '0.00',
      non_recurring_charges: '0.00',
      taxes_and_fees: '0.00',
      total_new_charges: '0.00',
      
      // Detail of New Charges
      total_outbound_dedicated_calls: '0',
      total_outbound_dedicated_minutes: '0',
      total_outbound_dedicated_cost: '0',
      total_toll_free_calls: '0',
      total_toll_free_minutes: '0',
      total_toll_free_cost: '0',
      total_free_calls: '0',
      total_free_minutes: '0',
      total_free_cost: '0',
      total_new_usage_charges_calls: '0',
      total_new_usage_charges_minutes: '0',
      total_new_usage_charges_cost: '0',
      total_taxes_and_fees: '0'
    };

    let clear_att = {
      // Summary of Charges
      new_usage_charges: '0.00',
      recurring_charges: '0.00',
      non_recurring_charges: '0.00',
      taxes_and_fees: '0.00',
      total_new_charges: '0.00',
      
      // Detail of New Charges
      total_outbound_dedicated_calls: '0',
      total_outbound_dedicated_minutes: '0',
      total_outbound_dedicated_cost: '0',
      total_toll_free_calls: '0',
      total_toll_free_minutes: '0',
      total_toll_free_cost: '0',
      total_free_calls: '0',
      total_free_minutes: '0',
      total_free_cost: '0',
      total_new_usage_charges_calls: '0',
      total_new_usage_charges_minutes: '0',
      total_new_usage_charges_cost: '0',
      total_taxes_and_fees: '0'
    };

    // Rendering the changes
    this._render = true;
    this.setState( {
      inputs_wcs: clear_wcs,
      inputs_att: clear_att,
      date: first_day_of_the_month
    } );
  }

  // Clears the fields but leaves the date
  onClear( ){
    
    // Inputs (stores all the inputs)
    let clear_wcs = {  
      // Summary of Charges
      new_usage_charges: '0.00',
      recurring_charges: '0.00',
      non_recurring_charges: '0.00',
      taxes_and_fees: '0.00',
      total_new_charges: '0.00',
      
      // Detail of New Charges
      total_outbound_dedicated_calls: '0',
      total_outbound_dedicated_minutes: '0',
      total_outbound_dedicated_cost: '0',
      total_toll_free_calls: '0',
      total_toll_free_minutes: '0',
      total_toll_free_cost: '0',
      total_free_calls: '0',
      total_free_minutes: '0',
      total_free_cost: '0',
      total_new_usage_charges_calls: '0',
      total_new_usage_charges_minutes: '0',
      total_new_usage_charges_cost: '0',
      total_taxes_and_fees: '0'
    };

    let clear_att = {
      // Summary of Charges
      new_usage_charges: '0.00',
      recurring_charges: '0.00',
      non_recurring_charges: '0.00',
      taxes_and_fees: '0.00',
      total_new_charges: '0.00',
      
      // Detail of New Charges
      total_outbound_dedicated_calls: '0',
      total_outbound_dedicated_minutes: '0',
      total_outbound_dedicated_cost: '0',
      total_toll_free_calls: '0',
      total_toll_free_minutes: '0',
      total_toll_free_cost: '0',
      total_free_calls: '0',
      total_free_minutes: '0',
      total_free_cost: '0',
      total_new_usage_charges_calls: '0',
      total_new_usage_charges_minutes: '0',
      total_new_usage_charges_cost: '0',
      total_taxes_and_fees: '0'
    };

    this._render = true;
    this.setState( {
      inputs_wcs: clear_wcs,
      inputs_att: clear_att
    } );
  }

  // Renders all the components
  render() {
    return (
      <div className={'vform'} key={'vform_key'}>
        {this.onRenderTitle()}
        {this.onRenderHeader()}
        <div className={'vform-content'}>
          {this.onRenderLeftBody()}
          {this.onRenderRightBody()}
          {this.onRenderFooter()}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( InvoiceForm ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/invoice/components/InvoiceForm.js